import { AuthRoleIdEnum } from 'constants/user'

export const roleOptions = [
  {
    label: 'Owner',
    value: AuthRoleIdEnum.OWNER
  },
  {
    label: 'Admin',
    value: AuthRoleIdEnum.ADMIN
  },
  {
    label: 'Coach',
    value: AuthRoleIdEnum.COACH
  },
  {
    label: 'Player',
    value: AuthRoleIdEnum.PLAYER
  }
]

export function getRoleName(value: number): string {
  const role = roleOptions.find(option => option.value === value)
  return role?.label ?? 'Player'
}
